const selector = {
    btnCardDelete: '.js_card_delete',
    btnCardDefault: '.js_default_card',
    btnChangeDefault: '.card-non-default-label',
    checkTerms: '#check_terms',
    btnSubmitMK: '#btn_submit_mk',
    checkTermsME: '#check_terms_me',
    btnSubmitME: '#btn_submit_me'
};

export { selector };